import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useAuth } from "../../../../hooks";

const SearchBar = ({
  selected,
  placeholder,
  handleSearch,
  handleDeleteAdmin,
  handleUpdateAdminRole,
  handleUpdateAdminStatus,
}) => {
  const { currentUser } = useAuth();
  const [statusOptions, setStatusOptions] = useState(false);
  const [roleOptions, setRoleOptions] = useState(false);

  useEffect(() => {
    if (selected && selected.length < 1) {
      setStatusOptions(false);
      setRoleOptions(false);
    }
  }, [selected]);

  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        // value={""}
        onChange={
          handleSearch ? (e) => handleSearch(e) : () => console.log("search")
        }
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          {currentUser?.role === "super" && (
            <Fragment>
              <TrendingFlatIcon fontSize="large" style={{ color: "#242424" }} />
              {/* <span
                style={statusTextSTyles}
                onClick={() => handleDeleteAdmin()}
              >
                Delete
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000" }}
              /> */}
              <span
                style={{
                  ...statusTextSTyles,
                  color: statusOptions ? "#9447AF" : "#00A7CD",
                }}
                onClick={() => {
                  setStatusOptions(true);
                  setRoleOptions(false);
                }}
              >
                Status
              </span>
            </Fragment>
          )}
          {statusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminStatus("invited")}
              >
                Invited
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminStatus("active")}
              >
                Active
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminStatus("inactive")}
              >
                Inactive
              </span>
            </Fragment>
          )}
          {currentUser?.role === "super" && (
            <Fragment>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000" }}
              />
              <span
                style={{
                  ...statusTextSTyles,
                  color: roleOptions ? "#9447AF" : "#00A7CD",
                }}
                onClick={() => {
                  setRoleOptions(true);
                  setStatusOptions(false);
                }}
              >
                Role
              </span>
            </Fragment>
          )}

          {roleOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminRole("manager")}
              >
                Manager
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminRole("standard")}
              >
                Standard
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminRole("moderator")}
              >
                Moderator
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateAdminRole("super")}
              >
                Super
              </span>
            </Fragment>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
